import React from 'react'
import FooterStyle03 from '../Components/Footers/FooterStyle03'

const Footer = () => {
  return (
    <div>
        {/* Footer Start */}
        <FooterStyle03 theme="dark" className="bg-gradient-to-r from-[#003479] to-[#0879bd] text-white consulting-footer" />
                {/* Footer End */}

    </div>
  )
}

export default Footer